import { type RequestType } from './types';

/**
 * ajax请求
 * @param type 请求类型
 * @param url 请求url
 * @param data 请求payload
 * @returns
 */
export const ajax = async (type: RequestType, url: string, data?: object, token?: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    var xhr = new XMLHttpRequest();
    xhr.open(type, url, true);
    xhr.timeout = 5000;
    xhr.setRequestHeader('Content-Type', 'application/json');
    if (token && token !== '') {
      xhr.setRequestHeader('token', token);
    }
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200 || xhr.status == 304) {
          var res = JSON.parse(xhr.responseText);
          if (res.success) {
            resolve(res);
          } else {
            reject(res);
          }
        } else {
          try {
            reject(JSON.parse(xhr.responseText));
          } catch (error) {
            reject(xhr.responseText);
          }
        }
      }
    };
    if (type === 'GET') {
      xhr.send(null);
    }
    if (type === 'POST') {
      xhr.send(JSON.stringify(data));
    }
  });
};

/**
 * 获取url参数的值
 * @param name
 * @returns
 */
export const getQueryString = (name: string): string => {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return r[2];
  }
  return '';
};
